// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tester-panel {
    width: 300px;
    height: 563px;
    z-index: 99999 !important;
    position: absolute;
    right: 10px;
    top: 50px;
    color: rgb(240, 240, 240);
    background-color: rgb(46, 46, 48);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    border: 0px !important;
}

.tester-header {
    height: 30px;
    color: rgb(230, 230, 230);
    padding-left: 10px;
    cursor: move;
    line-height: 30px;
    background-color: rgb(0, 0, 0);
}

.tester-close {
    font-size: 28px;
    cursor: pointer;
    right: 5px;
    position: absolute;
    top: 0px;
}

.tester-body {
    overflow-y: auto;
    height: 350px;
    color: rgb(230, 230, 230);
}

.tester-output {
    overflow-y: auto;
    height: 180px;
    border-top: 1px solid gray;
    padding: 2px 2px 0px 2px;
    color: rgb(230, 230, 230);
    padding-left: 5px;
}

.output-item {
    display: block;
    font-size: 12px;
}

.svg-property {
    color: rgba(0, 0, 0, 0.75);
}

.svg-property span {
    display: block;
    font-size: 12px;
    margin: 0px 5px 0px 10px;
    color: rgb(230, 230, 230);
}

.svg-property input {
    width: 50%;
    display: inline-block;
    margin: 0px 10px 12px 10px;
    border: unset;
    background-color: inherit;
    color: rgb(230, 230, 230);
    background-color: rgb(66, 66, 66);
    height: 22px;
}

.svg-property button {
    height: 26px;
}
`, "",{"version":3,"sources":["webpack://./src/app/tester/tester.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,iCAAiC;IACjC,2EAA2E;IAC3E,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".tester-panel {\n    width: 300px;\n    height: 563px;\n    z-index: 99999 !important;\n    position: absolute;\n    right: 10px;\n    top: 50px;\n    color: rgb(240, 240, 240);\n    background-color: rgb(46, 46, 48);\n    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 2px 6px 0 rgba(0, 0, 0, 0.18);\n    border: 0px !important;\n}\n\n.tester-header {\n    height: 30px;\n    color: rgb(230, 230, 230);\n    padding-left: 10px;\n    cursor: move;\n    line-height: 30px;\n    background-color: rgb(0, 0, 0);\n}\n\n.tester-close {\n    font-size: 28px;\n    cursor: pointer;\n    right: 5px;\n    position: absolute;\n    top: 0px;\n}\n\n.tester-body {\n    overflow-y: auto;\n    height: 350px;\n    color: rgb(230, 230, 230);\n}\n\n.tester-output {\n    overflow-y: auto;\n    height: 180px;\n    border-top: 1px solid gray;\n    padding: 2px 2px 0px 2px;\n    color: rgb(230, 230, 230);\n    padding-left: 5px;\n}\n\n.output-item {\n    display: block;\n    font-size: 12px;\n}\n\n.svg-property {\n    color: rgba(0, 0, 0, 0.75);\n}\n\n.svg-property span {\n    display: block;\n    font-size: 12px;\n    margin: 0px 5px 0px 10px;\n    color: rgb(230, 230, 230);\n}\n\n.svg-property input {\n    width: 50%;\n    display: inline-block;\n    margin: 0px 10px 12px 10px;\n    border: unset;\n    background-color: inherit;\n    color: rgb(230, 230, 230);\n    background-color: rgb(66, 66, 66);\n    height: 22px;\n}\n\n.svg-property button {\n    height: 26px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
